import React, { Component } from 'react'
import { Flex } from 'reflexbox'
import CSSModules from 'react-css-modules'

import styles from './styles.scss'

class SpecItemComponent extends Component {
  render() {
    const {
      label,
      isModifiedPage,
      hideIcon,
      modifiedValue,
      initValue,
      icon,
    } = this.props

    return(
      <Flex styleName='specItem'>
        <Flex styleName='specLabel'>
          <span>{ label }</span>
        </Flex>
        <Flex styleName='specValue'>
          <span>{ modifiedValue }</span>
        </Flex>
        { isModifiedPage &&
          <Flex styleName='specValue'>
            <span>{ initValue }</span>
          </Flex>
        }
        { isModifiedPage &&
          <Flex styleName='specValue'>
            <span>{ hideIcon ? '' : icon }</span>
          </Flex>
        }
      </Flex>
    )
  }
}

export default CSSModules(SpecItemComponent, styles)
